import React from "react"
import { HighlightedText } from "../common"

export default () => (
    <div id="about" className="row no-gutters align-items-center justify-content-center text-center" style={{ height: "100vh" }}>
        <div className="d-none d-sm-block col-10 col-sm-5">
            <img alt="Rishi Vedpathak" src="/illustrations/about.svg" className="img-fluid" style={{ width: "90%" }} />
        </div>
        <div className="col-10 col-sm-5">
            <img alt="Rishi Vedpathak" src="/illustrations/about.svg" className="d-sm-none img-fluid" style={{ width: "90%" }} />
            <h4 className="mt-4">Hi..! I am <HighlightedText>Rishi(kesh) Vedpathak</HighlightedText>, a Passionate Front-End Developer from India.</h4>
            <h4 className="mt-4">I focus my attention and efforts on <HighlightedText>front-end development</HighlightedText> and to give people a <HighlightedText>great browsing experience</HighlightedText>. I enjoy facing new challenges and learning new things to expand and develop my skill set.</h4>
        </div>
    </div>
)